/** @jsxImportSource @emotion/react */

import { CustomField, CustomTextarea, disableColor, InfoContainer } from './styles';
import { organizersStoreSelector, selectOrganizerById } from '../../../store/selectors';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from 'store/store';
import { Copy } from 'lucide-react';
import EmptyButton from 'ud-ui/components/empty-button';
import Label from 'ud-ui/components/label';
import PlansBlock from './components/plans-block';
import UDText from 'ud-ui/components/text';
import UDTippy from 'ud-ui/components/tippy';
import { fetchOrganizers } from '../../../store/actions';
import { theme } from 'styles/theme/theme';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function OrganizerInfo() {
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams();
  const organizer = useSelector(selectOrganizerById(Number(id)));
  const { isLoaded } = useSelector(organizersStoreSelector);

  useEffect(() => {
    if (!isLoaded) {
      dispatch(fetchOrganizers());
    }
  }, [dispatch, isLoaded]);

  const { t } = useTranslation();

  const onClickCopy = (text: string) => {
    navigator.clipboard.writeText(text).then((_) => {
      toast.success('Сохранено в буфер обмена!');
    });
  };

  return (
    <InfoContainer>
      <div className="w-50">
        <Label text="Название организатора" className={'mb-4'}>
          <CustomField>
            <UDText type={'subhead'}>{organizer?.name}</UDText>
            {organizer?.name && (
              <UDTippy content={'Скопировать'} size={'xs'}>
                <EmptyButton color={theme.colors.Gray} onClick={() => onClickCopy(organizer?.name ?? '')} icon={<Copy size={14} />} />
              </UDTippy>
            )}
          </CustomField>
        </Label>
        <Label text="Тип спорта" className={'mb-4'}>
          <CustomField>
            <UDText type={'subhead'}>{t(`sportType.${organizer?.sportType}`)}</UDText>
          </CustomField>
        </Label>
        <Label text="Email" className={'mb-4'}>
          <CustomField>
            <UDText type={'subhead'}>{organizer?.email}</UDText>
            {organizer?.email && (
              <UDTippy content={'Скопировать'} size={'xs'}>
                <EmptyButton color={theme.colors.Gray} onClick={() => onClickCopy(organizer?.email ?? '')} icon={<Copy size={14} />} />
              </UDTippy>
            )}
          </CustomField>
        </Label>
        <Label text="Телефон" className={'mb-4'}>
          <CustomField>
            <UDText type={'subhead'}>{organizer?.phone}</UDText>
            {organizer?.phone && (
              <UDTippy content={'Скопировать'} size={'xs'}>
                <EmptyButton color={theme.colors.Gray} onClick={() => onClickCopy(organizer?.phone ?? '')} icon={<Copy size={14} />} />
              </UDTippy>
            )}
          </CustomField>
        </Label>
        <Label text="Город" className={'mb-4'}>
          <CustomField>
            <UDText type={'subhead'}>{organizer?.address.city}</UDText>
          </CustomField>
        </Label>
        <Label text="Описание" className={'mb-4'}>
          <CustomTextarea css={disableColor} readOnly rows={4} value={organizer?.description} />
        </Label>
      </div>
      <div className="w-50">
        <Label text="Информация о подписке организатора">
          <PlansBlock tournamentId={Number(id)} owner={organizer?.adminUser} />
        </Label>
      </div>
    </InfoContainer>
  );
}

export default OrganizerInfo;
